
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { privatePracticeProps as __Next_Translate_old_getServerSideProps__1a0fc0d5bc3__ } from "@/modules/puzzles/MistakePracticePage";
export { default } from "@/modules/puzzles/MistakePracticePage";

    async function __Next_Translate__getServerSideProps__1a0fc0d5bc3__(ctx) {
      const res = await __Next_Translate_old_getServerSideProps__1a0fc0d5bc3__(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/puzzles/mistakes/practice/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a0fc0d5bc3__ as getServerSideProps }
  